import { hashPassword, hash256, generateRandomToken, setCookie } from "./helpers";
import {
  IonButton,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonPage,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToolbar,
  useIonLoading,
  useIonRouter,
} from "@ionic/react";
import { Link, useHistory } from "react-router-dom";
import React, { Suspense, useEffect, useState } from "react";
import { Preferences } from "@capacitor/preferences";
import "./Login.css";
import Intro from "../components/Intro";
import SelectLang from "../components/selectLanguage";
import { useTranslation } from "react-i18next";
import { body } from "ionicons/icons";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "../firebaseconfig.js";

const INTRO_KEY = "intro-seen";

const Login: React.FC = () => {
  const router = useIonRouter();
  const [isPendingVerify, setIsPendingVerify] = useState(false);
  const [verifyId, setVerifyId] = useState("");

  const [t, i18n] = useTranslation("global");
  useEffect(() => {
    const checkStorage = async () => {
      const seen = await Preferences.get({ key: INTRO_KEY });
      setIntroSeen(seen.value === "true");
    };
    checkStorage();
  }, []);

  const ChangeLanguage = (value: string) => {
    i18n.changeLanguage(value);
  };

  const history = useHistory();
  const [present, dismiss] = useIonLoading();
  const [introSeen, setIntroSeen] = useState(false);

/*  const doLogin = async (event: any) => {
    event.preventDefault();
    await present("Iniciando sesión...");

    const email = ((event.target as HTMLFormElement)[0] as HTMLInputElement)
      .value;
    const password = ((event.target as HTMLFormElement)[1] as HTMLInputElement)
      .value;

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const cookies = document.cookie
        .split(";")
        .map((cookie) => cookie.split("=")[0]);
      if (cookies.includes("verifyId")) {
        setIsPendingVerify(false);
        dismiss();
        router.push("/app/tabs/tab1");
        return;
      }

      const response = await fetch("http://localhost:3007/api/send-code", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
        }),
      });

      setVerifyId((await response.json()).id);
      setIsPendingVerify(true);
      console.log("✅ Sesión iniciada:", userCredential.user);

      dismiss();
    } catch (error: any) {
      console.error("❌ Error al iniciar sesión:", error.message);
      alert("Correo o contraseña incorrectos");
      dismiss();
    }
  };
*/

const doLogin = async (event: any) => {
  event.preventDefault();
  await present("Iniciando sesión...");

  const email = ((event.target as HTMLFormElement)[0] as HTMLInputElement).value;
  const password = ((event.target as HTMLFormElement)[1] as HTMLInputElement).value;

  const passwordHash = await hash256(password);

  // Lista de 7 usuarios permitidos con su hash SHA-256
  const allowedUsers: { email: string; hash: string }[] = [
    { email: "userqroo1@mexicoprofundo.app", hash: "9b8769a4a742959a2d0298c36fb70623f2dfacda8436237df08d8dfd5b37374c" },
    { email: "userqroo2@mexicoprofundo.app", hash: "3c8b8ed3401c4b9b261a52277e6a18cb44e13bdbb13f8e0ddf5dcfa29035340d" },
    { email: "useryuc1@mexicoprofundo.app", hash: "c7cc9c9911b3221c6222b213f37acf1a75e75b02f392488ae481ec6721c7a6cd" },
    { email: "useryuc2@mexicoprofundo.app", hash: "1d4598d1949b47f7f211134b639ec32238ce73086a83c2f745713b3f12f817e5" },
    { email: "usermxprof1@mexicoprofundo.app", hash: "815292cdc38cb03d04f91680b71b5c0b7454f5e1484ae9155979726255e2773b" },
    { email: "usermxprof2@mexicoprofundo.app", hash: "e99d9635c3e6caae5d4d3444b7cfd985997a6b99c029ac1802f320e8c4a74c04" },
    { email: "usermxprof3@mexicoprofundo.app", hash: "9dbd5c893b5b573a1aa909c8cade58df194310e411c590d9fb0d63431841fd67" },
    { email: "superusr@mexicoprofundo.app", hash: "9dbd5c893b5b573a1aa909c8cade58df194310e411c590d9fb0d63431841fd67" }
  ];

  console.log(`Usuario: ${email}, Hash ingresado: ${passwordHash}`);


  const isAllowed = allowedUsers.some(
    (u) => u.email === email && u.hash === passwordHash
  );

  if (!isAllowed) {
    alert("Acceso restringido a usuarios autorizados");
    dismiss();
    return;
  }

  // ✅ Si está en la whitelist, generamos token y omitimos Firebase
  const accessToken = generateRandomToken(64);
  localStorage.setItem("accessToken", accessToken);
  setCookie("accessToken", accessToken, 7);
  localStorage.setItem("userEmail", email);

  dismiss();
  router.push("/app/tabs/tab1");
};


  const doVerify = async (event: any) => {
    event.preventDefault();
    await present("Verificando código...");
    const code = ((event.target as HTMLFormElement)[0] as HTMLInputElement)
      .value;

    try {
      const response = await fetch("http://localhost:3007/api/verify-code", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          code,
          id: verifyId,
        }),
      });
      const data = await response.json();
      dismiss();

      if (response.status !== 200) {
        alert("Código incorrecto");
      } else {
        document.cookie = "verifyId=valor123; path=/; max-age=2592000"; // 30 días
        router.push("/app/tabs/tab1");
      }
    } catch (error: any) {
      console.error("Error al verificar el código:", error.message);
      alert("Código incorrecto");
    }
    dismiss();
  };

  const finishIntro = async () => {
    console.log("FIN");
    setIntroSeen(true);
    Preferences.set({ key: INTRO_KEY, value: "true" });
  };

  // const PopoverOptions = {
  //     component: <Flag country='AR'/>,
  //     cssClass : 'course-popover'
  //   }

  return (
    <>
      {!introSeen ? (
        <Intro onFinish={finishIntro} />
      ) : (
        <>
          <IonPage>
            <IonHeader color="light" class="ion-no-border ion-text-center">
              <div className="padding-left-lng">
                <SelectLang iconColorClass="gray-icon" />
              </div>
              <IonTitle className="title customLogin">
                {t("header.title")}
              </IonTitle>
            </IonHeader>
            <IonContent scrollY={false}>
              {!isPendingVerify && (
                <form onSubmit={doLogin}>
                  <p className="ion-margin-horizontal text">
                    {t("login.login-des")}
                  </p>
                  <div className="margenH">
                    <IonInput
                      aria-label="Email"
                      placeholder={t("login.placeholder-email")}
                      fill="outline"
                      labelPlacement="floating"
                      label={t("login.title-email")}
                      type="email"
                      className="Inputs-login"
                    ></IonInput>
                  </div>
                  <div className="margenH">
                    <IonInput
                      aria-label="Password"
                      placeholder={t("login.placeholder-pass")}
                      fill="outline"
                      labelPlacement="floating"
                      label={t("login.title-pass")}
                      type="password"
                      className="ion-margin-top ion-margin-bottom Inputs-login"
                    ></IonInput>
                  </div>
                  <br></br>
                  <IonButton
                    expand="block"
                    size="default"
                    className="botoncustom ion-text-capitalize"
                    type="submit"
                  >
                    {t("login.button-login")}
                  </IonButton>
                  <div className="container">
                    <div className="line"></div>
                    <span className="text">o</span>
                    <div className="line"></div>
                  </div>
                  <IonButton
                    expand="block"
                    fill="outline"
                    color="medium"
                    size="default"
                    className="botoncustom ion-text-capitalize"
                  >
                    {t("login.button-consult")}
                  </IonButton>
                </form>
              )}
              {isPendingVerify && (
                <form onSubmit={doVerify}>
                  <div className="margenH">
                    <IonInput
                      aria-label="Password"
                      placeholder={t("login.placeholder-pass")}
                      fill="outline"
                      labelPlacement="floating"
                      label={t("login.title-pass")}
                      type="password"
                      className="ion-margin-top ion-margin-bottom Inputs-login"
                    ></IonInput>
                    <IonButton
                      expand="block"
                      size="default"
                      className="botoncustom ion-text-capitalize"
                      type="submit"
                    >
                      {t("login.button-login")}
                    </IonButton>
                  </div>
                </form>
              )}
            </IonContent>
            <IonFooter
              id="footertransp"
              class="ion-no-border ion-padding ion-margin-bottom ion-text-center"
            >
              <p className="text margin-text-login">
                {t("login.question-account")}
                <Link to="/register" className="link">
                  &nbsp;{t("login.suggestion-register")}
                </Link>
              </p>
            </IonFooter>
          </IonPage>
        </>
      )}
    </>
  );
};

export default Login;
